<template>
  <div class="user-contact-details" v-if="otherUserStatus">

    <!-- <pre class="mini-pre">myUserId: {{myUserId}}</pre> -->
    <!-- <pre class="mini-pre">contactId: {{contactId}}</pre> -->

    <div v-if="isMyself" class="small-caps" style="color: #AAA">
      preview, what other people can see:
    </div>
    <h3 class="card-title">
      <strong>
        {{otherUserStatus.displayName || otherUserPublic.username}}
        <template v-if="otherUserStatus.displayName === 'Unknown'">
          ({{otherUserPublic.username}})
        </template>
      </strong>
    </h3>

    <el-alert
      v-if="contactNotConfirmed && !isMyself"
      class="mb-2"
      type="error"
      title="Info"
      :closable="false"
      show-icon>
      Contact not yet confirmed.
    </el-alert>

    <!-- TODO: Zeitzone anzeigen / vacation mode / availability anzeigen -->
    <div class="d-flex mb-2">
      <img
        class="user-image mr-2"
        style="border-radius: 5px"
        :src="otherUserStatus.profilePic|defaultUserPic"
        width="128"
        height="128" />
      <table class="w-100 table-sm">
        <tr>
          <td><strong>Joined Goalpilot</strong></td>
          <td>{{otherUserPublic.createdAt|longDate}}</td>
        <tr>
        </tr>
          <td><strong>Goalpilot level:</strong></td>
          <td>{{otherUserPublic.level}} 🥇 ({{otherUserPublic.cachedGoalcoins}} x 💎) </td>
        <tr>
        </tr>
          <td><strong>Job title:</strong></td>
          <td>{{otherUserPublic.jobTitle}} </td>
        <tr>
        </tr>
        <tr>
          <td><strong>Online status:</strong></td>
          <td>{{otherUserStatus.isOnline ? 'online' : 'offline'}} </td>
        </tr>
        <tr v-if="!otherUserStatus.isOnline">
          <td><strong>Last seen:</strong></td>
          <td>{{otherUserStatus.lastSeen|fromNow}} </td>
        </tr>
        <tr>
          <td><strong>Status message:</strong></td>
          <td>
            <template v-if="isMyself">
              <inline-editable-text
                style="border: 1px dashed grey"
                @change="onSetStatusText"
                :value="otherUserStatus.statusMessage"
                :inline="false"
                :reset-on-update="false"
                :reset-on-cancel="false"
                :lost-focus-is-update="true"
              />
            </template>
            <template v-else>
              {{otherUserStatus.statusMessage}}<br />
            </template>
          </td>
        </tr>
        <tr v-if="otherUserPublic.birthday">
          <td><strong>Birthday:</strong></td>
          <td>{{otherUserPublic.birthday|birthdayDate}} ({{otherUserPublic.birthday|fromNow}})</td>
          <!-- show something cool, if current date matches birthday -->
        </tr>
      </table>
    </div>

    <!-- TODO: Bug bounty summary -->
    <!-- <pre class="mini-pre">otherUserPublic: {{otherUserPublic.$state}}</pre> -->

    <collapse-group title="Privacy settings" :init-collapse="true" class="mb-2">
      <div v-if="!contactNotConfirmed" class="">
        <ul  class="list-group">
          <li :class="{
            'list-group-item p-1': true,
            'list-group-item-success': otherUsersContactInformationAboutMe.allowDropTasks,
          }">
            This user <strong>{{otherUsersContactInformationAboutMe.allowDropTasks ? 'enabled' : 'did not enable'}}</strong> task dropping.
          </li>
          <li :class="{
            'list-group-item p-1': true,
            'list-group-item-success': otherUsersContactInformationAboutMe.allowInterrupt,
          }">
            This user is <strong>{{otherUsersContactInformationAboutMe.allowInterrupt ? 'ok with being contactated right now' : 'is working on something and is currently in DND mode'}}</strong>.
          </li>
        </ul>
        <!-- <pre class="mini-pre">otherUsersContactInformationAboutMe: {{otherUsersContactInformationAboutMe}}</pre> -->
      </div>

      <div class="mb-4 mt-4">
        <el-switch class="mt-2" v-model="allowDropTasks" active-text="Allow this user to send tasks to me" :disabled="isMyself" />
        <el-switch class="mt-2" v-model="allowInterrupt" active-text="Allow this user to interrupt me" :disabled="isMyself" />

        <!-- <pre class="mini-pre">myContactInformationAboutOtherUser: {{myContactInformationAboutOtherUser}}</pre> -->
      </div>
    </collapse-group>

    <collapse-group title="Shared commitment" :init-collapse="false" class="mb-2" v-if="!isMyself">
      <div class="d-flex justify-content-between" v-if="myContactInformationAboutOtherUser.sharedIncommingCommitmentId">
        <div style="align-self: center; font-weight: bold" class="mr-2">Inbox {{otherUserStatus.displayName}}</div>
        <div class="commitment-draggable p-1 w-75">
          <InlineCommitmentWithProgress
            v-if="checkIfGoalHasBeenAccepted( myContactInformationAboutOtherUser.sharedGoalId )"
            :goal-id="myContactInformationAboutOtherUser.sharedGoalId"
            :commitment-id="myContactInformationAboutOtherUser.sharedIncommingCommitmentId"
            :active="true"
            :selected="true" />
          <p v-else class="p-2">
            Goal has not been accepted yet.
          </p>
        </div>
      </div>
      <div class="d-flex justify-content-between" v-if="otherUsersContactInformationAboutMe.sharedIncommingCommitmentId">
        <div style="align-self: center; font-weight: bold" class="mr-2">Your Inbox</div>
        <div class="commitment-draggable p-1 w-75">
          <InlineCommitmentWithProgress
            v-if="checkIfGoalHasBeenAccepted( otherUsersContactInformationAboutMe.sharedGoalId )"
            :goal-id="otherUsersContactInformationAboutMe.sharedGoalId"
            :commitment-id="otherUsersContactInformationAboutMe.sharedIncommingCommitmentId"
            :active="true"
            :selected="true" />
          <p v-else class="p-2">
            Goal has not been accepted yet.
          </p>
        </div>
      </div>
      <p class="" v-if="!myContactInformationAboutOtherUser.sharedIncommingCommitmentId && !otherUsersContactInformationAboutMe.sharedIncommingCommitmentId">
        No shared commitment yet. Send a task to this user to create one.
      </p>
    </collapse-group>

    <collapse-group title="Current task" :init-collapse="false" class="mb-2" v-if="activeTaskIfSharedGoal && !contactNotConfirmed /* HACK */">
      <el-alert
        title="Current task"
        type="info"
        :closable="false"
        class="mb-2 mt-2"
        style="width: auto">

        <div class="d-flex w-100">
          <inline-goal-card-minimal :goal="activeTaskIfSharedGoal.goal" />

          <div style="font-size: 10pt">
            <strong>{{otherUserStatus.displayName}}</strong>

            is currently working on <router-link :to="'/goal/' + otherUserStatus.goalId + '/member/' + otherUserStatus.memberId + '/task/' + otherUserStatus.taskId " >
              <strong>{{activeTaskIfSharedGoal.name}}</strong>
            </router-link>.

            <br /><br />

            Task duration: {{otherUserStatus.taskDuration|hoursMinutes}}
            <br />
            Start at: {{otherUserStatus.taskRecordingStartedAt * 1e3|longTime}}
            <!-- TODO: Use KanbanListDuration.vue -->
          </div>
        </div>

        <!-- {{activeTaskIfSharedGoal.goal.name}} -->
        <!-- {{activeTaskIfSharedGoal.goal.picture}} -->
        <!-- <pre class="mini-pre">{{activeTaskIfSharedGoal}}</pre> -->
      </el-alert>
    </collapse-group>

    <div class="d-flex justify-content-between">
      <el-button @click="onUnfriendUser" type="danger" plain :disabled="isMyself">Unfriend User</el-button>
      <el-button @click="onGoToChat" :disabled="isMyself">Chat</el-button>
      <!-- <el-button @click="onCreateSharedInbox" :disabled="isMyself">Create Inbox for this User</el-button> -->
    </div>

    <!-- TODO: Show DND mode, Timer = DND -->
    <!-- TODO: Show link to shared commitment -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { mapReady } from "@/api/misc";
import SidebarMixin from '@/components/TodayPage/Elements/SidebarMixin'
import InlineCommitmentWithProgress from '@/components/Inline/InlineCommitmentWithProgress';
// import BugBounty from '@/components/ContactPage/BugBounty'

// TODO: Also support tasks

export default {
  mixins: [ SidebarMixin ],
  props: {
    contactId: {
      required: false,
    },
    isMyself: {
      default: false
    },
  },
  data: () => ({
  }),
  created() {
    this.$api.contact_add_if_not_cached( this.contactId );
    this.$api.contact_add_if_not_cached( this.myUserId );
  },
  computed: {
    ...mapReady("commitments"),
    ...mapGetters("dayplanner", [
      "view_selected_date",
    ]),

    myUserId() {
      return this.$models.user.defaultUserId;
    },

    myUserStatus() {
       // return this.$models.userSettings.getters.get_profile_pic
      return this.$models.userContact.get_contact_by_id( this.myUserId ) || {
        displayName: 'loading...',
        profilePic: null
      }
    },

    otherUserStatus() {
      return this.$models.userContact.get_contact_by_id( this.contactId ) || {
        displayName: 'loading...',
        profilePic: null
      }
    },

    otherUserPublic() {
      return this.$models.userPublic.subscribeNode( this.contactId )
    },

    myContactInformationAboutOtherUser() {
      return this.$models.userContact.with({ uid: this.myUserId }).subscribeNode( this.contactId )
    },

    otherUsersContactInformationAboutMe() {
      return this.$models.userContact.with({ uid: this.contactId }).subscribeNode( this.myUserId )
    },

    contactNotConfirmed() {
      return this.otherUsersContactInformationAboutMe.$state['.exists'] === false;
    },

    activeTaskIfSharedGoal() {
      if ( this.otherUserStatus.taskId ) {

        let goalId   = this.otherUserStatus.goalId;
        let taskId   = this.otherUserStatus.taskId;
        let memberId = this.otherUserStatus.memberId;

        // Check if goal is shared goal
        let all_goal_ids = Object.keys( this.$models.goalMeta.getters.all_goals_user );

        // console.log("all_goal_ids", all_goal_ids, goalId, taskId, memberId)

        // TODO: fetchNode vs. subscribeNode
        if ( goalId && all_goal_ids.includes( goalId ) && memberId ) {
          let task = this.$models.taskMeta.with({ goalId, uid: memberId }).fetchNode( taskId )

          task.goal = this.$models.goalMeta.getNode( goalId );
          return task;
        }

        return null; // Other user is working on something, but we don't have access
      }
      return null;
    },

    allowDropTasks: {
      get() { return this.myContactInformationAboutOtherUser.allowDropTasks; },
      set(value) {
        this.$models.userContact
          .update( this.contactId, { allowDropTasks: value } )
      }
    },

    allowInterrupt: {
      get() { return this.myContactInformationAboutOtherUser.allowInterrupt; },
      set(value) {
        this.$models.userContact
          .update( this.contactId, { allowInterrupt: value } )
      }
    },
  },
  methods: {
    ...mapActions('app', [ 'goToChat' ]),

    checkIfGoalHasBeenAccepted( goalId ) {

      // TODO: Does not check if goal was deleted
      let all_goal_ids = Object.keys( this.$models.goalMeta.getters.all_goals_user );
      return all_goal_ids.includes( goalId );
    },

    onUnfriendUser() {
      // xTODO: Ask for confirmation
      // xTODO: Remove me from other users contact list
      // xTODO: Remove user from my contact list

      return this.$confirm(
        `Are you sure you want to unfriend ${this.otherUserStatus.displayName} (${this.otherUserPublic.username})?`,
        'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
      }).then(() => {
        this.$api.contact_rem({ contactUserId: this.contactId }).then(() => {
          this.$emit('close')
          this.$notify({
            type: 'success',
            message: `Removed ${this.otherUserStatus.displayName}' from your contact list.`
          });
        });
      }).catch(() => {})
    },

    onGoToChat() {
      if ( ![ 'dayplanner',
              'weekplanner',
              'dayplanner-taskpage',
              'weekplanner-taskpage'
        ].includes( this.$route.name ) ) {
        // Navigate to dayplanner if we're somewhere else right now
        this.$router.push('/dayplanner')
      }
      this.goToChat({ contactId: this.contactId })
      this.$emit('close')
    },

    /* onCreateSharedInbox() {
      console.log("onCreateSharedInbox")
      // this.$api.contact_create_shared_commitment({ contactUserId });
      this.$emit('close')
    }, */

    onSendMessage() {
      this.$models.userMsgInbox.with({ uid: this.contactId }).add({
        senderUserId: this.$models.user.defaultUserId,
        message: this.message,
      }).then(() => {
        this.message = '';
        this.show_message_modal = false;
        // this.$message('Message sent')
      })
    },

    onMarkMessageAsSeen(message) {
      message.update({ unread: false })
    },

    onDragStart(item) {
      console.log('FlowTasklist onDragStart', item)
      this.$emit('drag-task-start', item)
    },

    onDragEnd(destination) {
      console.log('FlowTasklist onDragEnd', destination)
      this.$emit('drag-task-end', destination)
    },

    onSetStatusText(text) {
      this.$models.userStatus.update( this.myUserId, { statusMessage: text } )
    }
  },
  components: {
    // BugBounty,
    InlineCommitmentWithProgress,
  }
};
</script>
